(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('covid-individual', {
            parent: 'entity',
            url: '/covid-individual',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'CovidIndividuals'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/covid-individual/covid-individuals.html',
                    controller: 'CovidIndividualController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('covid-individual-detail', {
            parent: 'entity',
            url: '/covid-individual/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'CovidIndividual'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/covid-individual/covid-individual-detail.html',
                    controller: 'CovidIndividualDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'CovidIndividual', function($stateParams, CovidIndividual) {
                    return CovidIndividual.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'covid-individual',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('covid-individual-detail.edit', {
            parent: 'covid-individual-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/covid-individual/covid-individual-dialog.html',
                    controller: 'CovidIndividualDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CovidIndividual', function(CovidIndividual) {
                            return CovidIndividual.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('covid-individual.new', {
            parent: 'covid-individual',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/covid-individual/covid-individual-dialog.html',
                    controller: 'CovidIndividualDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                dob: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('covid-individual', null, { reload: 'covid-individual' });
                }, function() {
                    $state.go('covid-individual');
                });
            }]
        })
        .state('covid-individual.edit', {
            parent: 'covid-individual',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/covid-individual/covid-individual-dialog.html',
                    controller: 'CovidIndividualDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CovidIndividual', function(CovidIndividual) {
                            return CovidIndividual.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('covid-individual', null, { reload: 'covid-individual' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('covid-individual.delete', {
            parent: 'covid-individual',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/covid-individual/covid-individual-delete-dialog.html',
                    controller: 'CovidIndividualDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CovidIndividual', function(CovidIndividual) {
                            return CovidIndividual.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('covid-individual', null, { reload: 'covid-individual' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
